import AuthRoutes from '../apiRoutes/AuthRoutes';
import CompanyRoutes from '../apiRoutes/CompanyRoutes';
import { GET, POST, POST_JSON } from './ConsumeApiController';

export async function searchEntities(searchTerm)
{
    const response = await POST_JSON(CompanyRoutes.Entities.SearchEntities,{searchTerm});
    return response;
}